module.exports = __webpack_public_path__ + "img/9788983925824.399847a6.jpg";